import { queryOptions, useQuery } from '@tanstack/react-query'
import getRefData from '../../services/ruutsApi/refData/getRefData'
import { queryKeys } from './queryKeys'

const EXCLUSION_AREA_TYPE_KEY = 'RefExclusionAreaType'

export const exclusionAreaTypesQueryOptions = (programId: number | undefined) =>
  queryOptions({
    queryKey: queryKeys.exclusionAreaTypes(programId),
    queryFn: ({ signal }) =>
      getRefData(EXCLUSION_AREA_TYPE_KEY, { programIds: [programId as number], signal }),
    // Reference data is immutable per deploy — same policy as form definitions.
    staleTime: Infinity,
  })

export const useExclusionAreaTypes = ({ programId }: { programId: number | undefined }) =>
  useQuery({
    ...exclusionAreaTypesQueryOptions(programId),
    // PROGRAM_IDS.SARA is 0, so a truthiness guard would disable the query for every SARA farm.
    enabled: programId != null,
  })
